enum HttpMethod {
    Delete = 'DELETE',
    Get = 'GET',
    Patch = 'PATCH',
    Post = 'POST',
    Put = 'PUT',
    Head = 'HEAD',
}

export { HttpMethod };
